module.exports = __webpack_public_path__ + "img/Beckmann.bbf582a3.jpg";